module.exports = __webpack_public_path__ + "img/dortje_gaertner.92348fc.jpg";